/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsCustomSacSendData } from './hosports-custom-sac-send.data';
import { IHosportsCustomSacSendProps } from './hosports-custom-sac-send.props.autogenerated';

export interface IHosportsCustomSacSendViewProps extends IHosportsCustomSacSendProps<IHosportsCustomSacSendData> {}

/**
 *
 * HosportsCustomSacSend component
 * @extends {React.PureComponent<IHosportsCustomSacSendProps<IHosportsCustomSacSendData>>}
 */
class HosportsCustomSacSend extends React.PureComponent<IHosportsCustomSacSendProps<IHosportsCustomSacSendData>> {
    public render(): JSX.Element | null {
      return this.props.renderView(this.props);
    }
}

export default HosportsCustomSacSend;
